'StocktakeList'.list({expose: true, icon: 'HandPointRight'})
'Stocktakes'.title()
'Stocktake'.menuCaption()
'Back'.action({act: 'cancel'})
'Start new Stocktake'.action({act: 'add'})
'Stocktake'.datatype()
'stocktakeNumber'.field({key: true})
'stocktakeDate'.field()
'status'.field()
'Edit'.action({place: 'row', act: 'edit'})
'Enter Counts'.action({place: 'row', act: "edit", spec: 'EnterStocktakeCounts.js'})
'Trash'.action({place: 'row', act: 'trash'})
'StocktakeMaint.js'.maintSpecname()

'StocktakeList'.defaultSort({field: 'stocktakeDate', descending: true})
